import Request from '../utils/request'
import qs from 'qs'
const userapi = '/api'

/**
 * 用户登录接口
 * @param params
 */
export function login(params) {
    return new Request({
        url: userapi + '/login/check',
        method: 'post',
        params: params
    })
}

export function upload (data) {
    return Request({
        url: '/api/zuul/fs/files/upload',
        method: 'post',
        data
    })
}

export function searchs (data) {
    return Request({
        url: '/api/fs/files/search',
        method: 'post',
        params:data
    })
}

export function delFiles (data) {
    return Request({
        url: '/api/fs/files/delete',
        method: 'delete',
        params:data
    })
}

export function reqFunc(url,method,data,params,header) {
    return new Request({
        url: url,
        method: method,
        data:data,
        params:params,
        headers: header
    })
}


export function getSyncToken() {
    return Request({
        url: '/outApis/public/api/getToken',
        method: 'post',
        data: qs.stringify({
            appId: 'zongliankeji',
            appSecret: '82werec3babedxxxxd2138793c276678cfb3e6b9'
        })
    })
}



// WEBPACK FOOTER //
// ./src/api/index.js